import type { TypedAnalyticsContexts } from '@/analytics/snowplow/analytics-context.types';
import { AnalyticsTrackingProvider, useAnalyticsTracking } from '@/analytics/snowplow/AnalyticsTrackingContext';
import { buildContextId } from '@/analytics/snowplow/utils/buildContextId';
import type { ReactNode } from 'react';
import { useCallback } from 'react';

interface BaseAnalyticsContextProps {
  children: ReactNode;
}

export const BaseAnalyticsContext = ({ children }: BaseAnalyticsContextProps) => {
  const { uiEvent } = useAnalyticsTracking();

  const updateTrackingContext = useCallback(
    (ctx: TypedAnalyticsContexts): TypedAnalyticsContexts => ({
      ...ctx,
      uiEvent: {
        ...uiEvent,
        context_id: buildContextId('prescription_tab'),
      },
    }),
    [uiEvent],
  );

  return <AnalyticsTrackingProvider update={updateTrackingContext}>{children}</AnalyticsTrackingProvider>;
};
